module.exports = __webpack_public_path__ + "media/Loops 110 Pad.c1233c93.wav";